
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M23 17a.5.5 0 00-.5.5v5a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5v-5a.5.5 0 00-1 0v5c0 .827.673 1.5 1.5 1.5h20c.827 0 1.5-.673 1.5-1.5v-5a.5.5 0 00-.5-.5z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M12 0a.5.5 0 00-.5.5v19a.5.5 0 001 0V.5A.5.5 0 0012 0z","fill":"#00003C"}}),_c('path',{attrs:{"d":"M18.352 13.147a.5.5 0 00-.707 0l-5.646 5.646-5.646-5.646a.5.5 0 00-.707.707l6 6a.502.502 0 00.706 0l6-6a.5.5 0 000-.707z","fill":"#00003C"}})])
          )
        }
      }
    